import React, { CSSProperties } from 'react';
import DOMPurify from 'dompurify';
import './RichTextAtom.scss';

interface RichTextAtomProps {
  content: string; // The rich text to display, typically an HTML string
  className?: string; // Additional classes for styling overrides
  style?: CSSProperties; // Inline styles for customization
}

const RichTextAtom: React.FC<RichTextAtomProps> = ({ content, className = '', style }) => {
  // Sanitize the HTML content using DOMPurify
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <div
      className={`rich-text-atom overflow-hidden text-overflow-ellipsis ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }} // Render sanitized content
    />
  );
};

export default RichTextAtom;
